import React, { useEffect, useState } from 'react';
import { APIBase, APIGet } from '../../../services/API';
import { SmartContainer } from '../../../styles/Containers';
import { StyledB, StyledP } from '../../../styles/StyledHTML';


export const useUsage = () => {

    const [usage, setResult] = useState(null);
    const [usageString, setUsageString] = useState('')
    const [usageLoading, setLoading] = useState(false);
    const [usageBilling, setUsageBilling] = useState(null);

    const getTotals = async () => {

        setLoading(true);

        const path = `${APIBase}/v1/usage`;

        try {
            const res = await APIGet(path)
            const json = await res.json();
            setResult(json?.data);

            if (json?.data?.storage) {
                if (json?.data?.storage?.tb > 1) setUsageString(`${parseFloat(json?.data?.storage.tb).toFixed(2)} TB`);
                else if (json?.data?.storage?.gb > 1) setUsageString(`${parseFloat(json?.data?.storage.gb).toFixed(2)} GB`);
                else if (json?.data?.storage?.mb > 1) setUsageString(`${parseFloat(json?.data?.storage.mb).toFixed(2)} MB`);
                else if (json?.data?.storage?.kb > 1) setUsageString(`${parseFloat(json?.data?.storage.kb).toFixed(2)} KB`);
                else setUsageString(`${parseFloat(json?.data?.storage.bytes).toFixed(2)} B`);

                const billed = (json?.data?.storage?.tb < 2) ? 2 : json?.data?.storage?.tb;

                setUsageBilling(Math.ceil(billed));
            }



            setLoading(false);
            return json;
        } catch (error) {
            setLoading(false);
            return error;
        }

    }

    useEffect(() => {

        getTotals();

    }, [])


    return {
        usage,
        usageString,
        usageLoading,
        usageBilling
    }
}


export const StorageUsage = () => {

    const { usage, usageString, usageLoading, usageBilling } = useUsage();
    return (
        <SmartContainer>
            {usageLoading && (<p>Loading...</p>)}
            {usage && (
                <StyledP><StyledB>Total Storage: {usageString}</StyledB></StyledP>
            )}
            {usageBilling && (
                <StyledP light>You will be billed for: {usageBilling} TB</StyledP>
            )}
        </SmartContainer>
    )
}